import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "@/platform/components/AuthShell";
import { Button, TextField } from "@/platform/components/primitives";
import PasswordField from "@/platform/components/PasswordField";
import { api } from "@/platform/api";
import { postAuthPath } from "@/platform/pendingInvite";
import { useAuth } from "@/platform/AuthContext";

export default function Account() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const [vtoken, setVtoken] = useState("");
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [pwError, setPwError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = sessionStorage.getItem("pinlayr.signup.vtoken");
    if (!t) {
      navigate("/signup", { replace: true });
      return;
    }
    setVtoken(t);
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    setPwError("");
    if (!fullName.trim()) { setError("Please enter your full name."); return; }
    if (password.length < 8 || !/[A-Za-z]/.test(password) || !/\d/.test(password)) {
      setPwError("Use at least 8 characters, including a letter and a number.");
      return;
    }
    setLoading(true);
    try {
      const payload = await api.post("/api/auth/complete-signup", {
        verification_token: vtoken,
        full_name: fullName.trim(),
        password,
      });
      applyAuth(payload);      sessionStorage.removeItem("pinlayr.signup.email");
      sessionStorage.removeItem("pinlayr.signup.devcode");
      sessionStorage.removeItem("pinlayr.signup.vtoken");
      navigate(postAuthPath(payload), { replace: true });
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <div className="animate-in fade-in duration-500">
        <h1 className="text-[26px] font-semibold tracking-tight text-[#F4F5F8]">Almost there</h1>
        <p className="mt-2 text-[15px] text-[#98A0B0]">Set your name and a password to secure your account.</p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="account-form">
          <TextField
            id="fullname"
            label="Full name"
            placeholder="Alex Rivera"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            error={error}
            autoFocus
            data-testid="account-name"
          />
          <PasswordField value={password} onChange={setPassword} error={pwError} />
          <Button type="submit" loading={loading} data-testid="account-submit">Continue</Button>
        </form>
      </div>
    </AuthShell>
  );
}
